module.exports = __webpack_public_path__ + "static/media/melo2.6029ebce.ogg";